import React from "react";
import { AppBar, Toolbar, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title }) => {
  const navigate = useNavigate();

  return (
    <AppBar position="fixed" color="default" elevation={0} sx={{ top: 0, width: "100%", zIndex: 1100 }}>
      <Toolbar>
        <IconButton onClick={() => navigate(-1)} edge="start" sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default PageHeader;
